const DNC_FIELDS = {
  ID: {api_name: 'id', label: 'Id'},
  FIRST_NAME: {api_name: 'firstName', label: 'First name'},
  LAST_NAME: {api_name: 'lastName', label: 'Last name'},
  PHONE: {api_name: 'phoneNumber', label: 'Phone'},
  CREATED_AT: {api_name: 'createdAt', label: 'Created'},
  UPDATED_AT: {api_name: 'updatedAt', label: 'Updated'},
};

export {DNC_FIELDS};
